import { createBrowserHistory, createHashHistory } from 'history';

/**
 * Regex pattern for matching preview index files
 */
const PREVIEW_PATTERN = /^\/index\.([\da-f]{40})\.html/;

/**
 * Create history environment based on whether the URL points to the root index
 * file or a preview index file. If the root index is used, use the browser
 * history environment as all paths can resolve without the index.html.
 * Otherwise if the preview index is used, use a hash history environment to
 * preserve the preview index file during navigation.
 */
export const createHistory = () => {
  const { location: { pathname = '' } = {} } = window;
  const preview = PREVIEW_PATTERN.test(pathname);
  return preview ? createHashHistory() : createBrowserHistory();
};

/**
 * Export shared history singleton
 */
export const history = createHistory();
